import {
  selectFaceAuthorize,
  insertFaceAuthorize,
  insertAuthorize,
  clearAuthorize,
  deleteICAuthorize,
  selectFaceAuthorizeRecord,
  selectFaceAuthorizeOperation
} from "../../api/config/modules/FaceAuthorize"; 

const state = {
  selectFaceAuthorizeResponse: {}, // 修改属性名以避免与其他属性冲突
  insertFaceAuthorizeResponse: {},
  insertAuthorizeResponse: {},
  clearAuthorizeResponse: {},
  deleteICAuthorizeResponse: {},
  selectFaceAuthorizeRecordResponse: {},
  selectFaceAuthorizeOperation: {}
};

const mutations = {
  SET_SELECTFACEAUTHORIZE: (state, selectFaceAuthorizeResponse) => {
    state.selectFaceAuthorizeResponse = selectFaceAuthorizeResponse;
  },
  SET_INSERTFACEAUTHORIZE: (state, insertFaceAuthorizeResponse) => {
    state.insertFaceAuthorizeResponse = insertFaceAuthorizeResponse;
  },
  SET_INSERTAUTHORIZE: (state, insertAuthorizeResponse) => {
    state.insertAuthorizeResponse = insertAuthorizeResponse;
  },
  SET_CLEARAUTHORIZE: (state, clearAuthorizeResponse) => {
    state.clearAuthorizeResponse = clearAuthorizeResponse;
  },
  SET_DELETEICAUTHORIZE: (state, deleteICAuthorizeResponse) => {
    state.deleteICAuthorizeResponse = deleteICAuthorizeResponse;
  },
  SET_SELECTFACEAUTHORIZERECORD: (state, selectFaceAuthorizeRecordResponse) => {
    state.selectFaceAuthorizeRecordResponse = selectFaceAuthorizeRecordResponse;
  },
  SET_SELECTFACEAUTHORIZEOPERATION: (state, selectFaceAuthorizeOperation) => {
    state.selectFaceAuthorizeOperation = selectFaceAuthorizeOperation;
  }
};

const actions = {
  GET_SELECTFACEAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectFaceAuthorize(data)
        .then((res) => {
          commit("SET_SELECTFACEAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTFACEAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertFaceAuthorize(data)
        .then((res) => {
          commit("SET_INSERTFACEAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertAuthorize(data)
        .then((res) => {
          commit("SET_INSERTAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CLEARAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      clearAuthorize(data)
        .then((res) => {
          commit("SET_CLEARAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEICAUTHORIZE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteICAuthorize(data)
        .then((res) => {
          commit("SET_DELETEICAUTHORIZE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTFACEAUTHORIZERECORD: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectFaceAuthorizeRecord(data)
        .then((res) => {
          commit("SET_SELECTFACEAUTHORIZERECORD", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTFACEAUTHORIZEOPERATION: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectFaceAuthorizeOperation(data)
        .then((res) => {
          commit("SET_SELECTFACEAUTHORIZEOPERATION", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
